import { queryOptions, useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { GET_TEMPLATE_CREATION_RECORD_BY_TEMPLATE_ID } from '../../contracts';
import { getTemplateCreationRecordByTemplateId } from '../api/templates';

/** Saved creation-record query keyed by template id. */
export const templateCreationRecordByTemplateIdQueryOptions = (
  templateId: string | undefined
) =>
  queryOptions({
    queryKey: [GET_TEMPLATE_CREATION_RECORD_BY_TEMPLATE_ID, { templateId }],
    queryFn: async () => {
      if (!templateId) return null;
      try {
        const { data } = await getTemplateCreationRecordByTemplateId(templateId);
        return data;
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) return null;
        throw error;
      }
    },
    staleTime: 0,
    retry: false,
  });

export function useQueryTemplateCreationRecordByTemplateId({
  templateId,
  enabled = true,
}: {
  templateId: string | undefined;
  enabled?: boolean;
}) {
  return useQuery({
    ...templateCreationRecordByTemplateIdQueryOptions(templateId),
    enabled: enabled && !!templateId,
  });
}
